/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Toast_Pickup_ErrInputs */

const vi_cdo_toast_pickup_err = /** @type {(inputs: Cdo_Toast_Pickup_ErrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn thất bại`)
};

/**

* @param {Cdo_Toast_Pickup_ErrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_toast_pickup_err = /** @type {((inputs?: Cdo_Toast_Pickup_ErrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Toast_Pickup_ErrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_toast_pickup_err(inputs)
});